import { Divider } from '@mui/material';
import { FlexBoxRow } from '../FlexBoxRow';

import checked from 'src/assets/adgenerator/stepper/checked.svg';
import step2 from 'src/assets/adgenerator/stepper/step-2.svg';
import step1current from 'src/assets/adgenerator/stepper/highlighted/step-1.svg';
import step2current from 'src/assets/adgenerator/stepper/highlighted/step-2.svg';
import { WebsiteGraderStep } from 'src/components/providers/websiteGrader';

export const WebSiteGraderStepper = ({ currentStep }: { currentStep?: WebsiteGraderStep }): JSX.Element => {
  currentStep = currentStep ?? WebsiteGraderStep.COLLECT_USER_DETAILS;

  const Step1 =
    currentStep === WebsiteGraderStep.COLLECT_USER_DETAILS ? (
      <img src={step1current} id="step1" alt="step-1-current" height={24} width={24} />
    ) : (
      <img src={checked} id="step1" alt="step-1-done" height={24} width={24} />
    );

  const Step2 =
    currentStep === WebsiteGraderStep.COLLECT_BUSINESS_DETAILS ? (
      <img src={step2current} id="step2" alt="step-2-current" height={24} width={24} />
    ) : currentStep > WebsiteGraderStep.COLLECT_USER_DETAILS ? (
      <img src={checked} id="logo" alt="LOCALiQ" height={24} width={24} />
    ) : (
      <img src={step2} id="logo" alt="LOCALiQ" height={24} width={24} />
    );

  return (
    <FlexBoxRow sx={{ gap: 1, alignSelf: 'stretch' }}>
      {Step1}
      <Divider sx={{ borderColor: 'primary.light', borderWidth: 1, width: '7%' }} />
      {Step2}
    </FlexBoxRow>
  );
};
